export default __webpack_public_path__ + "static/media/call.d0d32e99.svg";